module.exports = __webpack_public_path__ + "img/data2-2.6a68f669.png";